export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10320.bf7610d9.jpg";